(function () {
  'use strict';

  document.querySelectorAll('[data-holiday-coupon]').forEach(function (coupon) {
    if (coupon.dataset.initialized || !window.fetch) return;
    coupon.dataset.initialized = 'true';
    var code = coupon.dataset.code;
    var label = coupon.dataset.couponLabel || 'holiday cards';
    var minimum = Number(coupon.dataset.minimumSpend) || 0;
    var cartUrl = coupon.dataset.cartUrl;
    var claim = coupon.querySelector('[data-coupon-claim]');
    var message = coupon.querySelector('[data-coupon-message]');
    var form = coupon.closest('form');
    var pending = null;
    var interacted = false;
    var submitQueued = false;

    function matchingCode(cart) {
      return (cart.discount_codes || []).find(function (discount) {
        return discount.code.toUpperCase() === code.toUpperCase();
      });
    }

    function showClaimed(discount) {
      coupon.dataset.claimed = 'true';
      claim.textContent = 'Claimed ✓';
      claim.setAttribute('aria-disabled', 'true');
      claim.setAttribute('aria-label', '20% off ' + label + ' claimed');
      message.textContent = discount.applicable
        ? '20% off applied to your ' + label + '.'
        : minimum
          ? code + ' saved. Spend $30+ on eligible prints to unlock 20% off.'
          : code + ' saved. Final savings shown at checkout.';
    }

    async function readCart() {
      var response = await fetch(cartUrl + '.js', { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error('Cart unavailable');
      return response.json();
    }

    async function applyCoupon() {
      claim.textContent = 'Claiming…';
      claim.setAttribute('aria-disabled', 'true');
      coupon.setAttribute('aria-busy', 'true');
      try {
        var cart = await readCart();
        var codes = (cart.discount_codes || []).map(function (discount) { return discount.code; });
        if (!matchingCode(cart)) codes.push(code);
        var response = await fetch(cartUrl + '/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: codes.join(',') })
        });
        if (!response.ok) throw new Error('Claim failed');
        var updatedCart = await response.json();
        var discount = matchingCode(updatedCart);
        if (!discount) throw new Error('Code was not saved');
        showClaimed(discount);
        return true;
      } catch (error) {
        claim.textContent = 'Try again';
        claim.removeAttribute('aria-disabled');
        message.textContent = 'Couldn’t claim. Try again or enter ' + code + ' at checkout.';
        return false;
      } finally {
        coupon.removeAttribute('aria-busy');
      }
    }

    claim.addEventListener('click', function (event) {
      event.preventDefault();
      if (pending || coupon.dataset.claimed === 'true') return;
      interacted = true;
      pending = applyCoupon().finally(function () { pending = null; });
    });
    claim.addEventListener('keydown', function (event) {
      if (event.key === ' ') { event.preventDefault(); claim.click(); }
    });

    // Finish an in-flight claim before the existing product handler adds cards.
    if (form) form.addEventListener('submit', function (event) {
      if (!pending) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (submitQueued) return;
      submitQueued = true;
      var submitter = event.submitter;
      pending.then(function (claimed) {
        submitQueued = false;
        if (claimed) form.requestSubmit(submitter || undefined);
      });
    }, true);

    // Photo uploaders use a type=button CTA and bypass native form submission.
    if (form) form.querySelectorAll('button[name="add"].add_to_cart').forEach(function (button) {
      button.addEventListener('click', function (event) {
      if (!pending) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (submitQueued) return;
      submitQueued = true;
      pending.then(function (claimed) {
        submitQueued = false;
        if (claimed) button.click();
      });
      }, true);
    });

    // Shopify stores the claimed code even when the cart is still empty.
    readCart().then(function (cart) {
      var discount = matchingCode(cart);
      if (discount && !interacted) showClaimed(discount);
    }).catch(function () { /* Claim remains available after a failed status check. */ });
  });
}());
